module.exports = __webpack_public_path__ + "ffe5f0b957a78d6643b5d0ed01ae019d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/app-integration-instructions/oidc-endpoints/oidc-endpoints.html
// module id = 1270
// module chunks = 0